<template>
    <div>
        <div class="flex clearfix">
            <!-- <div class="pic">
                <div class="main_pic">
                    <img :src="mainPic" v-show='mainPic'>
                </div>
                <ul v-show="picList.length > 1">
                    <li v-for="(item,index) in picList" :class="{active: index == picIndex}" :key="index"
                        @mouseenter="picEnter(index)">
                        <img :src="item">
                    </li>
                </ul>
            </div> -->
            <div class="pay">
                <!-- <div class="name">{{data.isWht ? navActTxt() : data.name}}
                    <span class="stock" v-show="$route.params.id == 127 || $route.params.id == 132">
                        库存剩余{{data.stock}}本
                    </span>
                </div> -->
                <tabs v-if='isHasPay' :preClick="tabPreClick" v-model='tabType'>
                    <tabsPane label='续费' keyword="renew" v-if="hasRenew">
                        <Wh5eRenewBuy v-if="isWH5E" ref='renewbuy' v-show='tabType == "renew"'  :whProduct='wenhuaProduct'/>
                        <Renew v-else ref='renewbuy' v-show='tabType == "renew"'  :whProduct='wenhuaProduct'/>
                    </tabsPane>
                    <tabsPane :label='isWH10 || isWH11 || isNewWH10? "加购数据" : "加购授权"' keyword="add" v-if="hasAdd && !isWH11 && !isWH10_7_17 && !isNewWH10">
                        <Wh5eNewAddBuy v-if="isWH5E" ref='addbuy' :data='addBuyData' />

                        <AddBuy v-else ref='addbuy' v-show='tabType == "add"' :data='addBuyData' />
                    </tabsPane>
                    <!-- <tabsPane :label="'套餐升级'" keyword="upgrade" v-if="$route.params.id == 76">
                        <Upgrade ref='upgrade' v-show='tabType == "upgrade"' />
                    </tabsPane> -->
                    <tabsPane :label="'新购'+(isWH10 || isWH11 || isNewWH10? '' : '账号')" keyword="new">
                        <Wh5eNewBuy v-if="isWH5E" ref='newbuy' v-show='tabType == "new"' :canOrderByMonth='canOrderByMonth' :canOrderByQuarter="canOrderByQuarter" :whProduct='wenhuaProduct' :data='newBuyData' />
                        <NewBuy v-else ref='newbuy' v-show='tabType == "new"' :canOrderByMonth='canOrderByMonth' :canOrderByQuarter="canOrderByQuarter" :whProduct='wenhuaProduct' :data='newBuyData' />
                    </tabsPane>
                </tabs>
                <CloudPay v-if="['39','78','79'].findIndex(v=> parseInt(v) == parseInt(this.$route.params.id)) >= 0" />
                <LessonChoose v-if="['46','107'].findIndex(v=> parseInt(v) == parseInt(this.$route.params.id)) >= 0" />
                <CourseCreditPage ref="course_credit" v-if="isCredit" :courseData="data.authorization"/>
                <div class="choose_seat_box" v-if='startChooseSeat'>
                    <p>听课形式：</p>
                    <AuthChooseItem @click='chooseSeat' :selected='quant == selectSeat.length && livetype == 1' :name='"现场选座"'/>
                    <AuthChooseItem @click='chooseLive' :selected='livetype == 2' :name='"线上听课"'/>
                    <p v-if='selectSeat.length > 0' class="little-label" style="padding-top: 15px;">已选择：{{livetype == 2 ? peixunke[$route.params.id] +' 线上直播' : selectSeat.map(v=>peixunke[$route.params.id] +' '+ v.seat).join(',')}}</p>
                </div>
                <div class="price_ctrl_wrapper"
                    v-show="((tabType == 'renew' && renewValidCross) || (tabType == 'add' && addValidCross) ||tabType == 'new') || !isHasPay"
                    :style="{paddingTop: isHasPay || isCredit ? '0' : '15px'}">
                    <div class="price" v-if="isCredit">
                        合计：
                        <span class="num" style="margin-right: 5px;">{{creadit_ischeck ? 0 : quant*price}}</span>元
                        <span @click="creadit_ischeck = !creadit_ischeck" style="cursor: default;">
                            <span class="credit_checkbox" :class="{check: creadit_ischeck}">
                                 
                            </span>
                            使用{{credit}}积分兑换
                        </span>
                    </div>
                    <div class="price" v-else v-html='mainPrice'></div>
                    
                    <a v-if='$route.params.id == 80' href="https://en.wenhua.com.cn/" target="_blank"
                        style="font-size:12px; color:blue;text-decoration:underline;float:left;margin-top:9px;margin-left:10px;">
                        PAYMENT IN US DOLLARS </a>

                    <div class="control" v-if="!isCredit">
                        数量

                        <div class="arrow"
                            :class="{disabled: disablePriceControl}">
                            <div class="arrow_down"
                                :class="{hide:disablePriceControl}"
                                @click="quantMin">-</div>
                            <input ref='countInput' @input="countInput" class="num" type="text"
                                v-if="!disablePriceControl" v-model="quant"
                                :style="{width: inputWidth}">
                            <span class="buynum"
                                v-if="disablePriceControl">{{quant}}</span>
                            <div class="arrow_up"
                                :class="{hide:disablePriceControl}"
                                @click="quantAdd">+</div>
                        </div>
                        <NormalButton v-if='["46","107"].includes($route.params.id)' style='width: 100px;background:#555;' class="buy" :theme='"red"' disabled
                            @click='buynow'>{{!startChooseSeat ? '预约下次课程' : '立即购买'}}</NormalButton>
                        <NormalButton v-else class="buy" :disabled='buyBtnDisable' :theme='"red"' ref='buy'
                            @click='buynow'>立即购买</NormalButton>
                        <!-- <NormalButton class="buy" :theme='"red"' >点击</NormalButton> -->

                    </div>
                    <div class="control" style="float:right;" v-else>
                        <NormalButton class="buy" :disabled='buyBtnDisable' :theme='"red"'
                            @click='convert'>{{creadit_ischeck ? '去兑换' : '立即购买'}}</NormalButton>
                    </div>
                </div>
                <template v-if="data.notice && data.notice.length>0">
                    <div class="info" v-if="!($route.params.id == 125) ||  $route.params.id == 127 || $route.params.id == 132">
                        <div class="title">注意事项</div>
                        <div class="line" v-for="(item,index) in data.notice" :key="index" v-html="item"></div>
                        <div style="margin-top: 5px;padding-left: 12px;" v-if="isWH7_8_9">
                            <div @click="fullScreen(1)" style="cursor: pointer;display: inline-block;color: #3c88ff;">程序化报备示例</div> / 
                            <div @click="fullScreen(2)" style="cursor: pointer;display: inline-block;color: #3c88ff;">外部系统接入申请示例</div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import tabs from "@/components/tabs"
    import tabsPane from '@/components/tabsPane'
    import NewBuy from '@/components/NewBuy'
    import AddBuy from '@/components/AddBuy'
    import Renew from '@/components/Renew'
    import Upgrade from '@/components/Upgrade'
    import CloudPay from '@/components/CloudPay'
    import LessonChoose from '@/components/LessonChoose'
    import config from '@/assets/js/config.js'
    import cookie from 'js-cookie'
    import wh from '@/assets/js/wh.js'
    import CourseCreditPage from '@/components/CourseCredit/CourseCreditPage'
    import Wh5eNewAddBuy from '@/components/wh5/Wh5eAddBuy.vue'
    import Wh5eRenewBuy from '@/components/wh5/Wh5eRenew.vue'
    import Wh5eNewBuy from '@/components/wh5/Wh5eNewBuy.vue'
    import example_1 from '../assets/image/example1.jpg'
    import example_2 from '../assets/image/example2.jpg'
    import example_3 from '../assets/image/example3.jpg'
    import example_4 from '../assets/image/example4.jpg'
    import example_5 from '../assets/image/example5.jpg'
    import example_6 from '../assets/image/example6.jpg'
    export default {
        name: 'Productpay',
        provide() {
            let self = this
            return {
                renewValidCross(x) {
                    self.renewValidCross = x
                    self.$store.commit('renewbuy/setCrossFlag', x)
                },
                addValidCross(x) {
                    self.addValidCross = x
                    self.$store.commit('addbuy/setCrossFlag', x)
                },
                changeAuthPrice(x) {
                    //修改附加项价格的时候，把附加项价格提交到对应的vuex模块（新购，加购，续费）
                    self.annexation = x
                    if (self.tabType == 'add') {
                        self.$store.commit('addbuy/setPrice', x)
                    } else if (self.tabType == 'new') {
                        self.$store.commit('newbuy/setPrice', x)
                    } else if (self.tabType == 'renew') {
                        self.$store.commit('renewbuy/setPrice', x)
                    }
                },
                changeAuthOldPrice(x) {
                    //只有在加购的情况下，要显示授权的原价格
                    if (self.tabType == 'add') {
                        self.oldAuthPrice = x
                    }
                },
                changeMainPrice(x) {
                    //目前只有续费会修改主价格
                    self.changeMainPrice(x)
                },
                currentPage() {
                    return self.tabType
                },
                buy() {
                    setTimeout(_ => {
                        self.$refs.buy.click()
                    })
                },
                globalTabType() {
                    return self.tabType
                },
                setMultipleAccounts (x) {
                    self.multipleAccounts = x
                    self.quant = x.length > 0 ? x.length : 1
                    self.$store.commit('renewbuy/setAccounts',x)
                },
                orderByMonth (price) {
                    self.orderLimit = 0
                    self.changeMainPrice(price || self.monthprice)
                    self.canOrderByMonth = true
                },
                orderByQuarter (price) {
                    self.orderLimit = 2
                    self.changeMainPrice(price || self.quarterprice)
                    self.canOrderByQuarter = true
                },
                orderByYear (price) {
                    self.orderLimit = 1
                    self.changeMainPrice(price || self.dataPrice)
                },
                orderByCancel () {
                    self.orderLimit = 1
                    if(self.productData.monthprice && self.productData.monthprice != self.productData.price) {
                        self.canOrderByMonth = true
                    } else {
                        self.canOrderByMonth = false
                    }
                    if(self.productData.quarterprice && self.productData.quarterprice != self.productData.price) {
                        self.canOrderByQuarter = true
                    } else {
                        self.canOrderByQuarter = false
                    }
                },
                isMonth () {
                    return self.isOrderByMonth
                },
                getPwdAddress() {
                    return self.data.pwdAddress
                },
                setHistoryIsPoping (val) {
                    self.historyIsPoping = val
                },
                setCredit (num) {
                    function formatNumber(num) {
                        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                    }
                    self.credit = num
                },
                setJianMian (x) {
                    self.jianmian = x
                }
            }
        },
        inject: ['navActTxt','setLoading'],
        components: {
            tabs,
            tabsPane,
            NewBuy,
            AddBuy,
            Renew,
            CloudPay,
            LessonChoose,
            Upgrade,
            CourseCreditPage,
            Wh5eNewAddBuy,
            Wh5eRenewBuy,
            Wh5eNewBuy
        },
        model: {
            prop: 'data',
            event: 'change'
        },
        props: {
            data: {
                default: {},
                type: Object
            }
        },
        methods: {
            fullScreen (x) {
                if (x == 1) {
                    let url 
                    if (this.isWH7) {
                        url = example_1
                    } else if (this.isWH8) {
                        url = example_3
                    } else if (this.isWH9) {
                        url = example_5
                    }
                    this.$market.fullScreenImage({url})
                }
                if (x == 2) {
                    let url 
                    if (this.isWH7) {
                        url = example_2
                    } else if (this.isWH8) {
                        url = example_4
                    } else if (this.isWH9) {
                        url = example_6
                    }
                    this.$market.fullScreenImage({url})
                }
            },
            convert (finish,load) {
                let selections = this.$refs.course_credit.getSelections()
                if (this.creadit_ischeck) {
                    //积分兑换
                    let ids = ''
                    if (selections.length > 0) {
                        ids = selections.map(v => v.id).join(',')
                    }
                    window.open('https://wt8.wenhua.com.cn/#/buy/videoClass?courseIds=' + btoa(ids))
                    finish()
                } else {
                    if (selections.length <= 0) {
                        finish()
                        return this.$market.alert({
                            content: '请选择课程！',
                        })
                    }
                    this.buynow(finish,load)
                }
            },
            tabPreClick () {
                return this.historyIsPoping
            },
            picEnter(index) {
                this.picIndex = index
            },
            quantAdd() {
                this.quant++
                this.countInput()
            },
            quantMin() {
                if (this.quant == 1) return
                else {
                    this.quant--
                    this.countInput()
                }
            },
            setBuyData(val) {
                this.productData = val
                //加购部分所需的数据配置
                this.addBuyData = val.configure.map(v => ({
                    ...v,
                    name: v.productName,
                    price: v.price,
                    monthprice: v.monthprice,
                    id: v.id,
                    link: v.link,
                    disable: true,
                    bought: false,
                    isTaoli: v.isTaoli
                }))
                let addInnerAuth = val.authorization.filter(v => v.isout == 0 && v.grouptype != 7 && v.grouptype != 8).map(v => ({
                    ...v,
                    cdisable: false
                }))
                let addOuterAuth = val.authorization.filter(v => v.isout == 1 && v.grouptype != 7 && v.grouptype != 8).map(v => ({
                    ...v,
                    cdisable: false
                }))
                let addHistoryData = val.authorization.filter(v => v.grouptype == 7 || v.grouptype == 8).map(v => ({
                    ...v,
                    cdisable: false
                }))
                let add_require = []
                if (addInnerAuth.length>0) {
                    add_require.push({
                        id:wh.randomId(),
                        name: '国内五档数据等',
                        sublist: addInnerAuth, //※※此处为数据的源头，必须要再数据源头上加上，后面组件需要的数据字段（cdisable等），后续特殊场景中修改这些字段时，才会被响应
                        disable: true,
                        bought: false
                    })
                }
                if (addOuterAuth.length > 0) {
                    add_require.push({
                        id:wh.randomId(),
                        name: '境外实时数据',
                        sublist: addOuterAuth, //※※此处为数据的源头，必须要再数据源头上加上，后面组件需要的数据字段（cdisable等），后续特殊场景中修改这些字段时，才会被响应
                        disable: true,
                        bought: false
                    })
                }
                if (addHistoryData.length > 0) {
                    add_require.push({
                        id:wh.randomId(),
                        name: '历史数据API',
                        link: 'https://www.wenhua.com.cn/guide/lssj.htm',
                        sublist: historyData, //※※此处为数据的源头，必须要再数据源头上加上，后面组件需要的数据字段（cdisable等），后续特殊场景中修改这些字段时，才会被响应
                        disable: true,
                        bought: false
                    })
                }
                if (this.addBuyData.length > 2) {
                    this.addBuyData = [...add_require,{type: 'line'},...this.addBuyData]
                } else {
                    this.addBuyData = [...this.addBuyData, ...add_require]
                }

                if (this.$route.params.id == '1' || this.$route.params.id == '124') {//如果是wh8或者wh9的产品，只能暂时固定写死（柏慧提的需求），把多账号数据调到境外数据后面
                    let target_index = this.addBuyData.findIndex(v => v.name == '多账号下单模块'),
                        plunge_index = this.addBuyData.findIndex(v => v.name == '境外实时数据'),
                        target = this.addBuyData[target_index]
                    
                    this.addBuyData.splice(target_index, 1)
                    this.addBuyData.splice(plunge_index, 0, target)
                }

                //新购部分所需的数据配置
                this.newBuyData = val.configure.map(v => ({
                    ...v,
                    name: v.productName,
                    price: v.price,
                    monthprice: v.monthprice,
                    id: v.id,
                    link: v.link,
                    disable: false,
                    isTaoli: v.isTaoli
                }))
                let nbauthorization = [...val.authorization.filter(v => v.isout == 0 && v.grouptype != 7 && v.grouptype != 8 && !v.isChecked), ...val
                    .authorization.filter(v => v.isout == 0 && v.grouptype != 7 && v.grouptype != 8 && v.isChecked)
                ]
                let interList = nbauthorization.map(v => ({
                    ...v,
                    cdisable: false
                }))
                let new_require = []
                if (interList.length > 0) {
                    new_require.push({
                        id:wh.randomId(),
                        name: this.$route.params.id == '80' ? '国内实时数据' : '国内五档数据等',
                        sublist: interList, //※※此处为数据的源头，必须要再数据源头上加上，后面组件需要的数据字段（cdisable等），后续特殊场景中修改这些字段时，才会被响应
                        disable: false
                    })
                }
                let outerList = val.authorization.filter(v => v.isout == 1 && v.grouptype != 7 && v.grouptype != 8).map(v => ({
                        ...v,
                        cdisable: false
                    }))
                if (outerList.length > 0) {
                    new_require.push({
                        id:wh.randomId(),
                        name: '境外实时数据',
                        sublist: outerList, //※※此处为数据的源头，必须要再数据源头上加上，后面组件需要的数据字段（cdisable等），后续特殊场景中修改这些字段时，才会被响应
                        disable: false
                    })
                }
                
                let historyData = val.authorization.filter(v => v.grouptype == 7 || v.grouptype == 8).map(v => ({
                        ...v,
                        cdisable: false
                    }))
                if (historyData.length > 0) {
                    new_require.push({
                        id:wh.randomId(),
                        name: '历史数据API',
                        link: 'https://www.wenhua.com.cn/guide/lssj.htm',
                        sublist: historyData, //※※此处为数据的源头，必须要再数据源头上加上，后面组件需要的数据字段（cdisable等），后续特殊场景中修改这些字段时，才会被响应
                        disable: false
                    })
                }
                if (this.newBuyData.length > 2) {
                    this.newBuyData = [...new_require, {type: 'line'}, ...this.newBuyData]
                } else {
                    this.newBuyData = [...this.newBuyData,...new_require]
                }
                if (this.$route.params.id == '1' || this.$route.params.id == '124') {//如果是wh8或者wh9的产品，只能暂时固定写死（柏慧提的需求），把多账号数据调到境外数据后面
                    let target_index = this.newBuyData.findIndex(v => v.name == '多账号下单模块'),
                        plunge_index = this.newBuyData.findIndex(v => v.name == '境外实时数据'),
                        target = this.newBuyData[target_index]
                    
                    this.newBuyData.splice(target_index, 1)
                    this.newBuyData.splice(plunge_index, 0, target)
                }


                this.wenhuaProduct = val.wenhuaProduct
                if(val.monthprice && val.monthprice != val.price) {
                    //注：2022年5月25日，柏慧确认去掉选则按月支付按年支付的方式，暂时保留此功能入口，去掉注释即可完整支持
                    this.canOrderByMonth = true

                    this.orderLimit = -1
                    this.monthprice = val.monthprice
                }
                if(val.quarterprice && val.quarterprice != val.price) {
                    this.canOrderByQuarter = true

                    this.orderLimit = -1
                    this.quarterprice = val.quarterprice
                }
            },
            chooseSeat () {
                // if (this.soldSeat.length >= 20 || 1) {
                //     
                // } else {
                    
                // }

                this.$market.alert({
                    content: '<div style="margin-bottom:40px;text-align:center;">手慢了~现场座位已满！</div>',
                    titleIcon: require('@/assets/image/tanhao1.png')
                })
                return

                this.$router.push({
                    path:'/chooseSeat',
                    query: {
                        count: this.quant,
                        id: this.$route.params.id
                    }
                })
                
            },
            chooseLive () {
                this.livetype = 2
                let guid = cookie.get('seat_guid')
                if (!guid) {
                    guid = wh.randomId()
                    cookie.set('seat_guid',guid)
                }
                this.$axios({
                    url: "/api/Order/CreateSeat",
                    method: "post",
                    data: {
                        guid,
                        rowCol: [[-1,-1]],
                        type: this.seattype,
                        Seat: '线上直播',
                        SeatType: this.livetype
                    }
                }).then(({data})=>{
                    console.log(data)
                })
            },
            async buynow(finish,load) {
                let self = this
                //柏慧要求，弹窗的时候按钮不loading
                finish && finish()
                //2021514  新增分笔付款，没传morderid
                if (this.$route.query.orderid && this.$route.params.id == '27') {
                    self.$store.commit('setOtherId', this.$route.query.orderid)
                }

                if (!this.quant) {
                    finish()
                    this.$market.alert({
                        content: '购买数量不能为0。'
                    })
                    return
                }
                let wh10Accross = true,wh10Account,wh10Phone,isWh10TryAccount,isWh10TryAccountDate,isWh10AutoJg, wh10State,wh10Msg,dzh
                if (['110','125', '126', '128', '130', '131', '138'].includes(this.$route.params.id) && this.tabType == 'new') {
                    
                    [wh10Accross,dzh] = await new Promise((resolve)=>{
                        let dzh,name
                        if (this.$route.params.id == 126 || this.$route.params.id == 128|| this.$route.params.id == 129) {
                            dzh = 'webwh5'
                            name = 'wh5'
                        } else if (this.$route.params.id == 110) {
                            dzh = "webnwh10"
                            name = "wh10"
                        } else if (this.$route.params.id == 125 || this.$route.params.id == 138) {
                            dzh = 'webwt11'
                            name = 'wh11'
                        } else if (this.$route.params.id == 130 || this.$route.params.id == 131) {
                            dzh = 'webwh11'
                            name = 'wh12'
                        }
                        this.$market.accountValid({
                            title: '手机号验证',
                            noPassword: true,
                            required: true,
                            notice: '请输入手机号（登录软件的账号）验证'+name+'账号状态。',
                            account: this.isclient ? this.$store.state.wh10ClientAccount : '',
                            disable: this.isclient,
                            accountLabel: '手机号/账号',
                            ok: (close,tip,account) => {
                                this.$axios({
                                    url: '/api/Product/GetWh10IsAccount?data='+(this.isclient ? this.$route.query.account : account)+'&isclient='+ this.isclient + '&dzh=' + dzh,
                                    method: "get",
                                })
                                .then(res => {
                                    if (!res.data.state) {
                                        this.$market.alert({
                                            content: res.data.message,
                                            mountHandle: close => {
                                                document.getElementById('res').addEventListener('click', ()=>{
                                                    this.$store.commit('setWh10ClientAccount',account)
                                                    this.tabType = 'renew'
                                                    close()
                                                })
                                            }
                                        })
                                    }
                                    wh10Account = res.data.account
                                    wh10Phone = res.data.phone
                                    isWh10TryAccount = res.data.isTransAccount
                                    isWh10TryAccountDate = res.data.edate
                                    isWh10AutoJg = res.data.isautojg
                                    resolve([res.data.state,res.data.dzh])
                                    close()
                                }).catch(e=>{
                                    finish()
                                    close()
                                    resolve(false)
                                })
                                
                            },
                            close: () => {
                                resolve([false])
                            }
                        })
                        
                    })
                    this.$store.commit('setIsClient', false)
                }
                if (!wh10Accross) return finish()
                //因为之前有弹窗，所以此处重新loading效果
                load()
                let guid = cookie.get('seat_guid')
                
                if (config.hasPay.indexOf(parseInt(this.$route.params.id)) < 0) {
                    //注释原因：暂时不判断，云主机资源，内网中给孙丽萍留的功能一直没有使用上
                    // if (config.hasYun(parseInt(this.$route.params.id)) && this.data.limited == '1') {
                    //     finish()
                    //     this.$market.alert({content: '你所选云主机资源紧缺，请先联系4008113366确认是否可以购买。'})
                    //     return
                    // }
                    let subids = ''
                    if (this.isCredit) {
                        subids = this.$refs.course_credit.getSelections().map(v => v.id).join(',')
                    }
                    this.$axios({
                            url: '/api/Order/NeiPan',
                            method: "post",
                            data: {
                                productId: parseInt(this.$route.params.id),
                                isDanAuthorization: false,
                                identityType: 2,
                                dzh: '',
                                xzh: '',
                                subids: subids,
                                buynum: parseInt(this.quant),
                                userCode: '',
                                ismajor: -1,
                                isjg: -1,
                                userSdate: '',
                                userEdate: '',
                                morderid: this.$route.params.id == 27 ? this.$store.state.otherOrderId : '',
                                guid,
                                isMonth: this.isOrderByMonth,
                                IsQuarter: this.isOrderByQuarter
                            },
                        })
                        .then(res => {
                            if (['46','107'].includes(this.$route.params.id)) {
                                finish()
                                if (this.startChooseSeat) {
                                    if (!res.data.seatDto || (res.data.seatDto && res.data.seatDto.seat == '')  &&  this.livetype == null) {
                                        this.$market.alert({
                                            content: '<div style="margin-bottom:40px;text-align: center;">请选择听课形式</div>'/*'您现在还没有选择教室座位'*/,
                                            btnTxt: '确定',
                                            titleIcon: require('@/assets/image/tanhao1.png')
                                            // agreeBtn: '确定'/*'取消'*/,
                                            // cancelBtn: '取消'/*'去选座'*/,
                                            // degreeCall: () => {
                                            //     // this.chooseSeat()
                                            // }
                                        })
                                        return
                                        
                                    } else if(res.data.seatDto && this.quant != res.data.seatDto.selectSeat.length && this.livetype == 1) {
                                        this.$market.agree({
                                            content: '您的购买数量和已选择数量不符，请继续选座',
                                            agreeBtn: '取消',
                                            cancelBtn: '去选座',
                                            degreeCall: () => {
                                                this.chooseSeat()
                                            }
                                        })
                                        return
                                    }
                                    this.$store.commit('setSeats',res.data.seatDto.seat)
                                } else {
                                    this.$market.subcribe()
                                    return
                                }
                            }
                            finish()
                            if (!res.data.status) {
                                return self.$market.alert({
                                    content: res.data.message
                                })
                            }
                            res.data.islive = self.livetype == 2
                            res.data.isMonth = this.isOrderByMonth
                            res.data.IsQuarter = this.isOrderByQuarter
                            self.$store.commit('setOrderInfo', res)
                            self.$emit('buy')
                        }).catch(e => {
                            finish()
                        })
                } else if (this.tabType == 'renew') {
                    if (!this.$store.state.renewbuy.fetchInfo) return this.$market.alert({
                        content: '请先验证续费账号。'
                    })
                    if (this.$refs.renewbuy.orderLimit == -1) {//如果没有选则购买期限
                        finish()
                        return this.$market.alert({
                            content: '请选择支付方式。'
                        })
                    }
                    var url = this.$refs.renewbuy.hasOut() ? '/api/Order/CMEIndex' : '/api/Order/NeiPan'
                    if(this.isWH5E) {
                        url = '/api/Wh5Order/CMEIndex'
                    }
                    var ids = this.$refs.renewbuy.selectIds
                    let data = {
                                productId: parseInt(this.$store.state.renewbuy.fetchInfo.result.product.id),
                                isDanAuthorization: this.$store.state.renewbuy.fetchInfo.result.isDanAuthorization,
                                identityType: 1,
                                dzh: this.$store.state.renewbuy.fetchInfo.user.dzh,
                                xzh: this.multipleAccounts.length > 0 ? this.multipleAccounts.join(',') : this.$store.state.renewbuy.fetchInfo.user.xzh,//多账号或者单帐号
                                IsDzh: this.multipleAccounts.length > 0 ? true : false,//是否为多账号续费
                                subids: ids,
                                buynum: parseInt(this.quant),
                                userCode: this.$store.state.renewbuy.fetchInfo.usercode,
                                ismajor: this.$store.state.renewbuy.fetchInfo.ismajor,
                                isjg: this.$store.state.renewbuy.fetchInfo.isjg,
                                userSdate: this.$store.state.renewbuy.fetchInfo.user.start_date,
                                userEdate: this.$store.state.renewbuy.fetchInfo.user.end_date,
                                morderid: this.$route.params.id == 27 ? this.$store.state.otherOrderId : '',
                                isMonth: this.isOrderByMonth,
                                IsQuarter: this.isOrderByQuarter
                            }
                    
                    this.$axios({
                        url: url,
                            method: "post",
                            data
                        })
                        .then(res => {
                            finish()
                            if (!res.data.status) {
                                return self.$market.alert({
                                    content: res.data.message
                                })
                            }
                            res.data.isMonth = this.isOrderByMonth
                            res.data.IsQuarter = this.isOrderByQuarter
                            res.data.hasHistory = this.$refs.renewbuy.hasHistoryData
                            if (res.data.hasHistory) {
                                res.data.isCme = true
                            }
                            if (this.isWH5E) {
                                res.data.wh5Phone = this.$store.state.renewbuy.fetchInfo.phone
                            }
                            if (this.isWH7E && this.jianmian) {
                                res.data.jianmian = true
                            }
                            self.$store.commit('setOrderInfo', res)
                            self.$emit('buy')
                        }).catch(e => {
                            finish()
                        })
                } else if (this.tabType == 'add') {
                    if (!this.$store.state.addbuy.fetchData) {
                        finish()
                        this.$market.alert({
                            content: '请先验证加购账号。'
                        })
                        return
                    }
                    if (this.$refs.addbuy.selectIds == '') {
                        finish()
                        this.$market.alert({
                            content: '请到下方选择加购授权内容。'
                        })
                        return
                    }
                    var url = this.$refs.addbuy.hasOut ? '/api/Order/CMEIndex' : '/api/Order/NeiPan'
                    if (this.isWH5E) {
                        url = '/api/Wh5Order/CMEIndex'
                    }
                    var ismajor = this.$refs.addbuy.hasMajor
                    var isjg = this.$refs.addbuy.hasOgz
                    var ids = this.$refs.addbuy.selectIds
                    var data = {
                        productId: this.isWH5E ? parseInt(this.$store.state.addbuy.fetchData.data.data.id) : parseInt(this.$store.state.addbuy.fetchData.data.productid), // 加购的产品号从接口中取，原parseInt(this.$route.params.id),
                        isDanAuthorization: false,
                        identityType: 3,
                        dzh: this.isWH5E ? this.$store.state.addbuy.fetchData.data.dzh : this.$store.state.addbuy.fetchData.data.bigacc,
                        xzh: this.$store.state.addbuy.fetchData.data.xzh,
                        subids: ids,
                        buynum: parseInt(this.quant),
                        userCode: this.$store.state.addbuy.fetchData.data.userCode,
                        ismajor: ismajor,
                        isjg: isjg,
                        userSdate: this.$store.state.addbuy.fetchData.data.stime,
                        userEdate: this.isWH5E ? this.$store.state.addbuy.fetchData.data.etime : this.$store.state.addbuy.fetchData.data.time,
                        morderid: this.$route.params.id == 27 ? this.$store.state.otherOrderId : ''
                    }
                    this.$store.commit('addbuy/setInterface', {
                        url,
                        data
                    })
                    this.$axios({
                            url: url,
                            method: "post",
                            data: data,
                        })
                        .then(res => {
                            finish()
                            if (!res.data.status) {
                                return self.$market.alert({
                                    content: res.data.message
                                })
                            }
                            if (this.isWH5E) {
                                res.data.wh5Phone = this.$store.state.addbuy.fetchData.data.phone
                            }
                            res.data.hasHistory = this.$refs.addbuy.hasHistoryData
                            if (res.data.hasHistory) {
                                res.data.isCme = true
                            }
                            
                            self.$store.commit('setOrderInfo', res)
                            self.$emit('buy')
                        }).catch(e => {
                            finish()
                        })
                } else if (this.tabType == 'new') {
                    if (this.$refs.newbuy.orderLimit == -1) {//如果没有选则购买期限
                        finish()
                        return this.$market.alert({
                            content: '请选择支付方式。'
                        })
                    }
                    if (!this.$refs.newbuy.selectIds && this.isWH5E) {
                        finish()
                        return this.$market.alert({
                            content: '请选择数据授权。'
                        })
                    }
                    
                    let wh5_data
                    if (this.isWH5E) {
                        let [wh5_cross, data] = await this.wh5Valid()
                        if (!wh5_cross) {
                            return finish()
                        }
                        wh5_data = data
                    }
                    var url = this.$refs.newbuy.hasOut ? '/api/Order/CMEIndex' : '/api/Order/NeiPan'
                    if (this.isWH5E) {
                        url = '/api/Wh5Order/CMEIndex'
                    }
                    var ismajor = this.$refs.newbuy.hasMajor
                    var isjg = this.$refs.newbuy.hasOgz
                    var ids = this.$refs.newbuy.selectIds
                    var data = {
                        productId:this.isWH5E ? wh5_data.data.id : parseInt(this.$route.params.id),
                        isDanAuthorization: false,
                        identityType: 2,
                        dzh: this.isWH5E ? wh5_data.dzh : dzh,
                        xzh: '',
                        subids: ids,
                        buynum: parseInt(this.quant),
                        userCode: '',
                        ismajor: ismajor,
                        isjg: isjg,
                        userSdate: '',
                        userEdate: '',
                        morderid: this.$route.params.id == 27 ? this.$store.state.otherOrderId : '',
                        isMonth: this.isOrderByMonth,
                        IsQuarter: this.isOrderByQuarter
                    }
                    this.$store.commit('newbuy/setInterface', {
                        url,
                        data
                    })
                    this.$axios({
                            url: url,
                            method: "post",
                            data
                        })
                        .then(res => {
                            finish()
                            if (!res.data.status) {
                                return self.$market.alert({
                                    content: res.data.message
                                })
                            }
                            res.data.wh10Account = wh10Account
                            res.data.wh10Phone = wh10Phone
                            res.data.wh5Phone = wh5_data?.phone
                            res.data.isWh5TransAccount = wh5_data?.isTransAccount
                            res.data.wh5Account = wh5_data?.account
                            res.data.isWh5Autojg = wh5_data?.isautojg
                            if (res.data.isWh5Autojg && self.$refs.newbuy.curProduct.name == '5C标准版' && self.$refs.newbuy.selectIds.split(',').length == 1) {
                                res.data.wh5OpenDate = wh5_data?.accounttime
                                res.data.isOnly5C = true
                            } else {
                                res.data.wh5OpenDate = wh5_data?.stime
                            }
                            
                            //如果是wh10验证过手机号之后进入购买页面的，购买页面上的手机号不允许修改，增加一个标识进行限制
                            if (wh10Phone) {
                                res.data.wh10LockPhone = true
                            }
                            res.data.isWh10TryAccount = isWh10TryAccount
                            res.data.isWh10TryAccountDate = isWh10TryAccountDate
                            res.data.isWh10AutoJg = isWh10AutoJg
                            res.data.isMonth = this.isOrderByMonth
                            res.data.IsQuarter = this.isOrderByQuarter
                            res.data.hasHistory = this.$refs.newbuy.hasHistoryData
                            if (res.data.hasHistory) {
                                res.data.isCme = true
                            }
                            self.$store.commit('setOrderInfo', res)
                            self.$emit('buy')
                            /**2023-1-1之后删除 */
                            let subnames = ids.split(',').map(id => this.newBuyData.find(v=>v.name.includes('国内五档')).sublist.find(v => v.id == id).productName)
                            self.$store.commit('newbuy/setTemporarySubNames', subnames.join(','))
                        }).catch(e => {
                            finish()
                        })
                }
            },
            async wh5Valid () {
                return new Promise(resolve => {
                    this.$market.accountValid({
                        title: '手机号验证',
                        noPassword: true,
                        required: true,
                        notice: '请输入手机号（登录软件的账号）验证wh5账号状态。',
                        account: '',
                        accountLabel: '手机号/账号',
                        ok: (close,tip,account) => {
                            this.$axios({
                                url: "/api/Wh5Order/Wh5AccountAdd?pid=129&account=" + account + "&identityType=2",
                                method: "get"
                            })
                            .then(res => {
                                if (!res.data.status) {
                                    this.$market.alert({
                                        content: res.data.message,
                                        confirmCall: () => {
                                            if (res.data.code == 229) {
                                                this.tabType = 'renew'
                                            }
                                        }
                                    })
                                }
                                resolve([res.data.status,res.data])
                                close()
                            }).catch(e=>{
                                close()
                                resolve([false, {}])
                            })
                            
                        },
                        close: () => {
                            resolve([false, {}])
                        }
                    })
                })
            },
            countInput() {
                if (!/^[0-9]*$/.test(this.quant)) {
                    this.$market.alert({
                        content: '请输入正确的数字'
                    })
                    if (this.quant < 0) {
                        this.quant = 1
                    } else {
                        this.quant = parseInt(this.quant)
                    }
                    return

                }
                if (this.quant > 9999999999) {
                    this.quant = 9999999999
                }
                this.inputWidth = parseFloat(getComputedStyle(this.$refs.countInput).fontSize) * this.quant.toString()
                    .length * 0.6 + 'px'
            },
            changeMainPrice(x) {
                //目前只有续费会修改主价格
                if (this.tabType == 'renew') {
                    this.price = x
                    this.$store.commit('renewbuy/setMainPrice', x)
                } else if (this.tabType == 'add') {
                    this.price = x
                    this.$store.commit('addbuy/setMainPrice', x)
                } else {
                    this.price = x
                }
            },
            exchange (finish) {
                this.$market.accountValid({
                            title: '云账号验证',
                            required: true,
                            notice: '请输入云账号和密码，验证账号状态。',
                            account: '',
                            accountLabel: '云账号',
                            labelWidth: 60,
                            ok: (close,tip,account, pwd) => {
                                
                                
                            },
                            close: () => {
                                finish()
                            }
                        })
            }
        },
        data: () => ({
            tabType: 'new',
            tabIndex: 0,
            picList: [],
            picIndex: 0,
            quant: 1,
            price: 0,
            monthprice: 0,
            quarterprice: 0,
            dataPrice: 0,
            annexation: 0,
            oldAuthPrice: 0,
            newBuyData: [
                // {
                //     name: '多账号下单模块',
                //     price: 1000,
                //     link: 'https://rich.wenhua.com.cn/center.asp?pid=7'
                // },
                // {
                //     name: '套利交易模块',
                //     price: 1000,
                //     link: 'https://rich.wenhua.com.cn/center.asp?pid=8'
                // },
                // {
                //     name: '国内五档数据等',
                //     price: 1000,
                //     sublist: [{
                //         name: 'xxx',
                //         price: 123,
                //         groupprice: 1234
                //     }]
                // },
                // {
                //     name: '境外实时数据',
                //     price: 1000,
                //     sublist: [{
                //         name: 'xxx',
                //         price: 123,
                //         groupprice: 1234
                //     }]
                // }
            ],
            addBuyData: [
                // {
                //     name: '多账号下单模块',
                //     price: 1000,
                //     link: 'https://rich.wenhua.com.cn/center.asp?pid=7'
                // },
                // {
                //     name: '套利交易模块',
                //     price: 1000,
                //     link: 'https://rich.wenhua.com.cn/center.asp?pid=8'
                // },
                // {
                //     name: '国内五档数据等',
                //     price: 1000,
                //     sublist: []
                // },
                // {
                //     name: '境外实时数据',
                //     price: 1000,
                //     sublist: []
                // }
            ],
            renewValidCross: false, //是否通过续费验证
            addValidCross: false, //是否通过加购验证
            wenhuaProduct: [], //新购中使用的主授权列表
            inputWidth: '',
            multipleAccounts: [],
            startChooseSeat: false, //开始选座，是否有培训班开课
            selectSeat: [], //已选座位
            peixunke: {
                46:'麦语言',
                107: '麦语言'
            },
            livetype: null,//授课形式
            seattype: null,
            soldSeat: [], //已售座位
            canOrderByMonth: false, //是否可以按月付费
            canOrderByQuarter: false, //是否可以按季付费
            orderLimit: 1, //-1 - 没选， 0 - 选按月， 1 - 选按年
            historyIsPoping: false,
            productData: null,
            credit: 0, //兑换积分
            creadit_ischeck: false,
            jianmian: false
        }),
        computed: {
            disablePriceControl () {
                if (this.isWH5E || this.isWH10 || this.isNewWH10 || this.isWH11) return true
                return (this.tabType == 'renew' && this.renewValidCross) || this.tabType == 'add'
            },
            mainPic() {
                return this.picList[this.picIndex]
            },
            mainPrice() {
                var quant = this.quant,
                    price = this.price,
                    annexation = this.annexation
                // if (this.orderLimit == -1 && this.canOrderByMonth) {
                //     return `<span class="m">￥</span><span class="num">--</span>&nbsp;元`
                // }
                if (this.tabType == 'add') { //加购只有授权价格
                    return `<span class="m">￥</span><span class="num">${quant*annexation}</span>&nbsp;元<br>单价：${quant*this.oldAuthPrice}&nbsp;元/${this.unit}`
                }
                if (this.isWH5E && this.tabType == 'renew') {
                    return `<span class="m">￥</span><span class="num">${quant*annexation}</span>&nbsp;元/${this.unit}`
                }
                let jiankou = 0
                if (this.isWH7E && this.tabType == 'renew' && this.jianmian) {
                    jiankou = config.wh7eJianMian
                }
                if (!annexation) {
                    if (this.isTaiLi) return `<span class="m">￥</span><span class="num">${quant*price}</span>&nbsp;元`
                    return `<span class="m">￥</span><span class="num">${quant*(price - jiankou)}</span>&nbsp;元/${this.unit}`
                }
                
                return `<span class="m">￥</span><span class="num">${quant*(price - jiankou)}</span>&nbsp;元<span
                        class="num">&nbsp;&nbsp;+${quant*annexation}&nbsp;</span>元/${this.unit}`
            },
            unit () {
                if (this.isOrderByQuarter) return '季/账号'
                else if (this.isOrderByMonth) return '月/账号'
                else return this.data.unit || ''
            },
            isHasPay() {
                return config.hasPay.findIndex(v => parseInt(v) == parseInt(this.$route.params.id)) >= 0 || this.data
                    .isContinue == 1
            },
            hasRenew() {
                return this.$route.params.id != '80'
            },
            hasAdd() {
                return this.$route.params.id != '80'
            },
            buyBtnDisable() {
                return this.$route.name == "Preview" // || (this.$route.params.id == 127 && Number(this.data.stock) <= 0) ?  true : false
            },
            isOrderByMonth () {
                return this.orderLimit == 0 && this.canOrderByMonth
            },
            isOrderByQuarter () {
                return this.orderLimit == 2 && this.canOrderByQuarter
            },
            isclient () {
                return this.$store.state.isclient
            },
            isWH10 () {
                return ['125', '126', '128', '129', '138'].includes(this.$route.params.id)
            },
            isNewWH10 () {
                return ['110'].includes(this.$route.params.id)
            },
            isWH10_7_17 () {
                return this.$route.params.id == 138
            },
            isWH5E () {
                return this.$route.params.id == 129
            },
            isWH7E () {
                return this.$route.params.id == 76
            },
            isWH11 () {
                return ['131'].includes(this.$route.params.id)
            },
            isWH7_8_9 () {
                return ['76', '123', '122', '1', '124'].includes(this.$route.params.id)
            },
            isWH7 () {
                return ['76', '123'].includes(this.$route.params.id)
            },
            isWH8 () {
                return [ '122', '1'].includes(this.$route.params.id)
            },
            isWH9 () {
                return ['124'].includes(this.$route.params.id)
            },
            isWH3 () {
                return ['139'].includes(this.$route.params.id)
            },
            isCredit () {
                //积分兑换
                return ['136'].includes(this.$route.params.id)
            },
            isTaiLi () {
                return ['132'].includes(this.$route.params.id)
            }
        },
        watch: {
            data: {
                handler: function (val) {
                    if (!val) return
                    this.picList = val.pic
                    this.price = val.price
                    this.dataPrice = val.price //存储备用
                    this.annexation = val.annexationPrice
                    if (val.classify && val.classify.length > 0 && val.classify[0].annexation) {
                        this.annexation = val.classify[0].annexation
                    }
                    //设置给加购使用的数据
                    this.setBuyData(val)
                },
                immediate: true,
                deep: true
            },
            tabType: {
                handler(val) {
                    //切换新购加购续费时，从vuex上获取之前存储的，附加项价格和数量，并显示
                    if (val == 'add') {
                        this.renewValidCross = false
                        this.addValidCross = this.$store.state.addbuy.crossflag
                        this.annexation = this.$store.state.addbuy.annexation
                        this.quant = this.$store.state.addbuy.quant
                        this.price = this.$store.state.addbuy.mainPrice
                        
                        this.$refs.addbuy.fromWh10SetOnceUser(this.$store.state.wh10ClientAccount)
                    } else if (val == 'new') {
                        this.renewValidCross = false
                        this.addValidCross = false
                        this.annexation = this.$store.state.newbuy.annexation
                        this.quant = this.$store.state.newbuy.quant
                        this.orderLimit = this.$refs.newbuy?.orderLimit == 0 ? 0 : (this.$refs.newbuy?.orderLimit || -1)
                        this.price = this.isOrderByMonth ? this.monthprice : this.dataPrice
                        if (this.isOrderByMonth) {
                            this.price = this.monthprice
                        } else if (this.isOrderByQuarter) {
                            this.price = this.quarterprice
                        } else {
                            this.price = this.dataPrice
                            setTimeout(() => {
                                if (this.isWH5E && this.$refs.newbuy.curProduct.name == '5C标准版') {
                                this.price = this.$refs.newbuy.curProduct.price
                            }
                            })
                        }
                    } else if (val == 'renew') {
                        this.renewValidCross = this.$store.state.renewbuy.crossflag
                        this.addValidCross = false
                        this.annexation = this.$store.state.renewbuy.annexation
                        this.quant = this.$store.state.renewbuy.quant
                        this.orderLimit = this.$refs.renewbuy?.orderLimit == 0 ? 0 : (this.$refs.renewbuy?.orderLimit || -1)
                        this.price = this.$store.state.renewbuy.mainPrice != null ? this.$store.state.renewbuy
                            .mainPrice : this.dataPrice
                        this.$refs.renewbuy.fromWh10SetOnceUser(this.$store.state.wh10ClientAccount)
                    }
                    this.$store.commit('setGlobalTabType', val)
                },
                immediate: true
            },
            quant(val) {
                let self = this
                //修改数量的时候，把当前的数量提交到对应的vuex模块中（新购，加购，续费）
                if (self.tabType == 'add') {
                    this.$store.commit('addbuy/setQuant', val)
                } else if (self.tabType == 'new') {
                    this.$store.commit('newbuy/setQuant', val)
                } else if (self.tabType == 'renew') {
                    this.$store.commit('renewbuy/setQuant', val)
                }
            },
            $route: {
                handler () {
                    if (['46','107'].includes(this.$route.params.id)) {
                        //如果是麦语言培训，要请求一下是否有培训班开课
                        this.setLoading(true)
                        this.$axios({
                            url: "/api/Order/GetMyypxsize",
                            method: "get"
                        }).then(({data,status})=>{
                            this.setLoading(false)
                            if (status && data) {
                                this.startChooseSeat = true
                                this.seattype = data.type
                                let guid = cookie.get('seat_guid')
                                if (!guid) {
                                    guid = wh.randomId()
                                    cookie.set('seat_guid',guid)
                                }
                                this.$axios({
                                    url: "/api/Order/GetSeat",
                                    method: "post",
                                    data: {
                                        type: this.seattype,
                                        guid
                                    }
                                }).then(({data})=>{
                                    this.selectSeat = data.data.selectSeat
                                    this.soldSeat = data.data.purchaseSeat
                                })
                            }
                        })
                    } else {
                        this.startChooseSeat = false
                    }
                    this.quant = 1
                    this.jianmian = false
                },
                immediate: true
            }
        },
        mounted() {
            if (this.$route.query.isrenew == 1) {
                this.tabType = "renew"
            } else if (this.$route.query.isadd == 1) {
                this.tabType = "add"
            }
            if (this.$route.query.livetype) {
                this.livetype = this.$route.query.livetype
            }
            if (this.$route.query.account) {
                this.$store.commit('setIsClient', true)
                this.setLoading(true)
                this.$axios({
                    url: "/api/Product/GetAccountDecode?data="+this.$route.query.account,
                    method: "get",
                }).then(({data})=>{
                    let account = data.result?.split('&')[0] || ''
                    let dzh
                    if (this.isWH10) {
                        dzh = 'webwt11'
                    } else if (this.isWH11) {
                        dzh = 'webwh11'
                    } else if (this.isNewWH10) {
                        dzh = 'webnwh10'
                    }
                    this.$axios({
                        url: '/api/Product/GetWh10IsAccount?data='+this.$route.query.account+'&isclient=true&dzh='+dzh,
                        method: "get",
                    }).then(res=>{
                        this.setLoading(false)
                        let isWh10TryAccount = res.data.isTransAccount
                        this.$store.commit('setWh10ClientAccount',account)
                        if (this.$route.query.type == 1 || isWh10TryAccount) {
                            // this.buynow()
                        } else if (this.$route.query.type == 2) {
                            //界面切到加购
                            this.tabType = 'add'
                            this.$refs.addbuy.fromWh10SetOnceUser(account)
                        } else {
                            //界面切到续费
                            this.tabType = 'renew'
                            
                            this.$refs.renewbuy.fromWh10SetOnceUser(account)
                        }
                    })
                })
                
                
            }
            
        },
        created () {
            if ([46,107].includes(this.$route.params.id)) {
                //默认选中直播
                this.chooseLive()
            }
            
        }
    }
</script>

<style scoped>
.credit_checkbox {
    display: inline-block;
    width: 16px;
    height: 16px;
    text-align: center;
    cursor: default;
    margin-left: 10px;
    background: url(../assets/image/VC_02.png) no-repeat center;
    position: relative;
    top: 3px;
}
.credit_checkbox.check {
    background: url(../assets/image/VC_01.png) no-repeat center;
}
.taili_tips {
    line-height: 34px;
    margin-left: 10px;
    color: #444;
    font-size: 13px;
}
.choose_seat_box .little-label {
    font-size: 12px;
    color: rgb(111, 111, 113);
    clear: both;
    padding: 0 0 4px;
    margin: 0;
}
.chooseSeat{
    font-size: 14px;
    color: #3c88ff;
    line-height: 30px;
    top: 3px;
    margin-left: 10px;
    text-decoration: underline;
}
.choose_seat_box p{
    font-size: 12px;
    padding-top: 10px;
    position: relative;
    margin-bottom: 4px;
    color: rgb(111, 111, 113);
}
.choose_seat_box::before {
    content: '';
    position: absolute;
    top:0;
    left: 10px;
    right: 10px;
    border-top: 1px dashed #999;
}
.choose_seat_box {
    position: relative;
    padding-left: 10px;
    background-color: rgb(245, 246, 248);
}
    .buynum {
        width: auto;
        padding: 0 5px;
        height: 27px;
        line-height: 26px;
        vertical-align: middle;
        text-align: center;
        outline: 0;
        float: left;
        border: 0;
        color: rgb(133, 133, 133);
        font-size: 14px;
    }

    .flex {
        display: flex;

    }

    .pay {
        /* padding-left: 30px; */
        /* flex: 1; */
        width: 100%;
        float: left;
        box-sizing: border-box;
    }

    .pay .name {
        font-size: 16px;
        color: #3c3c3c;
        font-weight: bold;
        margin-bottom: 20px;
    }

    .pay .price_ctrl_wrapper {
        overflow: hidden;
        background: rgb(247, 248, 250);
        padding-right: 10px;
        padding-bottom: 10px;
    }

    .pay .price {
        /* height: 30px; */
        color: rgb(135, 135, 135);
        font-size: 14px;
        padding-left: 8px;
        box-sizing: border-box;
        float: left;
    }

    .pay .stock {
        height: 30px;
        color: rgb(135, 135, 135);
        font-size: 14px;
        padding-left: 18px;
        box-sizing: border-box;
        line-height: 35px;
        font-weight: normal;
    }

    .pay .control {
        height: 30px;
        font-size: 12px;
        float: right;
    }

    .pay .control .num {
        width: 8px;
        padding: 0 5px;
        height: 27px;
        line-height: 24px;
        background: #fff;
        vertical-align: middle;
        text-align: center;
        outline: 0;
        float: left;
        border: 0;
        color: rgb(133, 133, 133);
    }

    .pay .control .num:disabled {
        background: transparent;
    }

    .arrow {
        display: inline-block;
        vertical-align: middle;
        height: 27px;
        overflow: hidden;
        border: 1px solid rgb(207, 211, 213);
        background: white;
    }

    .arrow.disabled {

        border: 1px solid transparent;
        background: transparent;
    }

    .arrow .arrow_up {
        width: 20px;
        line-height: 27px;
        height: 27px;
        cursor: pointer;
        overflow: hidden;
        zoom: 1;
        margin-bottom: 2px;
        float: left;
        text-align: center;
        color: rgb(133, 133, 133);
        font-size: 20px;
    }

    .arrow .arrow_up.hide {
        display: none;
    }

    .arrow .arrow_down {
        width: 20px;
        height: 27px;
        line-height: 27px;
        cursor: pointer;
        overflow: hidden;
        zoom: 1;
        float: left;
        text-align: center;
        font-size: 20px;
        color: rgb(133, 133, 133);
    }

    .arrow .arrow_down.hide {
        display: none;
    }

    .pay .buy {
        width: 78px;
        height: 27px;
        text-align: center;
        background: rgb(230, 0, 0);
        color: white;
        font-size: 14px;
        vertical-align: middle;
        margin-left: 15px;
        display: inline-block;
    }

    .pay .info {
        width: 100%;
        margin: 10px 0 0 0;
        padding: 8px 6px;
        background: rgb(245, 246, 248);
        box-sizing: border-box;
    }

    .pay .info .title {
        color: rgb(117, 117, 117);
        font-size: 14px;
        font-weight: bold;
        background: url(../assets/image/tanhao1.png) no-repeat 4px;
        background-size: 14px;
        padding-left: 25px;
        margin-bottom: 5px;
    }

    .pay .info .line {
        position: relative;
        padding: 0 0 0 12px;
        zoom: 1;
        color: #7a7a7a;
    }

    .pay .info .line::before {
        content: '';
        position: absolute;
        left: 5px;
        top: 8px;
        width: 2px;
        height: 2px;
        border-radius: 100%;
        background-color: #7a7a7a;
    }
    .pay .info .line >>> a {
        color:#3c88ff;
    }
</style>